export const formatBalance = (balance: string | number): string => {
  const parsedBalance = typeof balance === "string" ? parseFloat(balance) : balance;
  return parsedBalance.toFixed(6);
};